import { required } from 'vuelidate/lib/validators'

const requiredMsg = 'Обязательное поле'

export default vars => {
  return {
    kioskName: { required: { validator: required, message: requiredMsg } },
    apiKey: { required: { validator: required, message: requiredMsg } },
    serialNumber: { required: { validator: required, message: requiredMsg } },
    location: { required: { validator: required, message: requiredMsg } },
    type: { required: { validator: required, message: requiredMsg } },
    bannerType: { required: { validator: required, message: requiredMsg } },
    externalBannerType: { required: { validator: required, message: requiredMsg } },
    streamLogin: { required: { validator: required, message: requiredMsg } },
    streamPassword: { required: { validator: required, message: requiredMsg } }
  }
}
